<label
	*ngIf="control"
	class="c-radio"
	[class.c-radio--active]="isActive()"
	[class.c-radio--error]="hasError()"
	[class.c-radio--green]="theme === 'green'"
	[class.c-radio--disabled]="control.disabled"
	(click)="toggle($event)"
>
	<input type="radio" [formControl]="control" />

	<div class="c-radio__checkmark">
		<tvcore-icon name="checkmark"></tvcore-icon>
	</div>

	<span>
		<ng-content></ng-content>
	</span>
</label>
